import { createContext } from 'react';

export type FormValues = Record<string, string | string[]> | undefined;

export interface HelpChoosingContextProps {
    formValues: FormValues;
    setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
}

const HelpChoosingContext = createContext<HelpChoosingContextProps>({
    setFormValues: () => {
        // eslint-disable-next-line no-console
        console.warn('HelpChoosingContext::setFormValues called without provider');
    },
    formValues: undefined,
});

export default HelpChoosingContext;
